import { bindActionCreators } from 'redux';
import React, { Component} from 'react';
import { connect } from 'react-redux';
import Header from '../layout/Header';
import TypeContent from './TypeContent';
import { Link } from 'react-router';



export default class ActiveTours extends Component {

    componentWillMount() {

    }

    componentDidMount() {



    }

    componentDidUpdate() {

    }


    componentWillUnmount() {

        this.props.toursActions.setMapConfig({
            listByMap: false
        });
    }

    
    
    render () {

        return (

            <section className="section section__gallery types">
                <div className="blured__background blured__background_fixed types__blured types__blured_active"></div>

                    <Header />
                    <div className="container container_full-width">
                        

                        <TypeContent type="active" />
                    </div>
            </section>
        );
    }
}






// WEBPACK FOOTER //
// ./src/common/components/type/Active.js